import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconWarningTriangle = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2026 3.22063C16.4088 3.06187 15.5914 3.06187 14.7976 3.22063C13.0337 3.57341 11.5137 4.68293 10.6401 6.25537L2.39226 21.1016C1.91644 21.958 1.66675 22.9216 1.66675 23.9014C1.66675 27.0854 4.24792 29.6666 7.43196 29.6666H24.5682C27.7522 29.6666 30.3334 27.0854 30.3334 23.9014C30.3334 22.9216 30.0837 21.958 29.6079 21.1016L21.36 6.25537C20.4864 4.68293 18.9664 3.57341 17.2026 3.22063ZM16.0001 18.3333C15.4478 18.3333 15.0001 17.8856 15.0001 17.3333V12C15.0001 11.4477 15.4478 11 16.0001 11C16.5524 11 17.0001 11.4477 17.0001 12V17.3333C17.0001 17.8856 16.5524 18.3333 16.0001 18.3333ZM17.0001 22C17.0001 22.5523 16.5524 23 16.0001 23C15.4478 23 15.0001 22.5523 15.0001 22V21.3333C15.0001 20.781 15.4478 20.3333 16.0001 20.3333C16.5524 20.3333 17.0001 20.781 17.0001 21.3333V22Z"
      fill="currentColor"
    />
  </SvgIcon>
)
